import axios from '../../utilities/axios';
import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';
// import { failureMessage } from '../Notifications/actions';
import { primaryApi } from '../../utilities/apiEndpointUtility';

import {
	getProducts,
	getProductsCompleted,
	getProductsFailed
} from './productsSlice';

export const getProductsEpic = (action$) =>
	action$.pipe(
		ofType(getProducts.type),
		mergeMap(async () => {
			try {
				const products = await axios.get(`${primaryApi()}/api/v1/products`);

				if (products.status === 200) {
					return products.data;
				}

				throw new Error('Get Products request failed');
			} catch (e) {
				return {
					error: e.message
				};
			}
		}),
		switchMap((res) => {
			return [getProductsCompleted(res)];
		}),
		catchError((error, source) => {
			return merge(
				of(
					getProductsFailed(error.message)
					// failureMessage(error.message)
				),
				source
			);
		})
	);

export default [getProductsEpic];
